import { render, staticRenderFns } from "./BaseDrawer.vue?vue&type=template&id=4eda8452&scoped=true&"
import script from "./BaseDrawer.vue?vue&type=script&lang=js&"
export * from "./BaseDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BaseDrawer.vue?vue&type=style&index=0&id=4eda8452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eda8452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/marcosalazar/Documents/HM/Timelapse/timelapse-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eda8452')) {
      api.createRecord('4eda8452', component.options)
    } else {
      api.reload('4eda8452', component.options)
    }
    module.hot.accept("./BaseDrawer.vue?vue&type=template&id=4eda8452&scoped=true&", function () {
      api.rerender('4eda8452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseDrawer.vue"
export default component.exports